<template>
  <div class="grid-replacements">
    <div class="grid-replacements__container">
      <mds-loader v-if="loading" />
      <div v-else class="grid-replacements__wrapper">
        <template v-if="haveData">
          <filterBar
            @updateFilters="updateFilters"
            @updateProductFunds="updateProduct"
            :fiduciary="selectedFiduciary"
            :client="selectedClient"
            :hideFilters="hideFilters"
            :clearAll="clearAllFilters"
          />
          <template v-if="replacements.length">
            <div
              v-for="(category, index) in replacements"
              :key="index"
              class="grid-replacements__category"
            >
              <h4 class="grid-replacements__category__name">{{ category.category }}</h4>

              <div class="grid-replacements__category__container">
                <table class="mds-data-table">
                  <thead class="mds-data-table__header">
                    <tr class="mds-data-table__row">
                      <th class="mds-data-table__header-cell" width="20" scope="col">
                        <div class="mds-data-table__header-cell-inner"></div>
                      </th>
                      <th class="mds-data-table__header-cell" width="80" scope="col">
                        <div class="mds-data-table__header-cell-inner">
                          Status
                        </div>
                      </th>
                      <th class="mds-data-table__header-cell" width="80" scope="col">
                        <div class="mds-data-table__header-cell-inner">
                          Pending
                        </div>
                      </th>
                      <th class="mds-data-table__header-cell" width="*" scope="col">
                        <div class="mds-data-table__header-cell-inner">
                          Fund Name
                        </div>
                      </th>
                      <th class="mds-data-table__header-cell" width="85" scope="col">
                        <div class="mds-data-table__header-cell-inner">
                          Ticker
                        </div>
                      </th>
                      <th class="mds-data-table__header-cell" width="117" scope="col">
                        <div class="mds-data-table__header-cell-inner">
                          SecID
                        </div>
                      </th>
                      <th class="mds-data-table__header-cell" width="120" scope="col">
                        <div class="mds-data-table__header-cell-inner">
                          <template v-if="tabsCurrent === tabsProduction">
                            Active
                          </template>
                        </div>
                      </th>
                      <th class="mds-data-table__header-cell" width="80" scope="col">
                        <div class="mds-data-table__header-cell-inner"></div>
                      </th>
                      <th class="mds-data-table__header-cell" width="20" scope="col">
                        <div class="mds-data-table__header-cell-inner"></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="mds-data-table__body">
                    <template v-for="fund in category.funds">
                      <tr
                        :key="`category-fund-${fund.id}`"
                        class="mds-data-table__row grid-replacements__fund"
                      >
                        <td class="mds-data-table__cell"></td>
                        <td class="mds-data-table__cell">
                          <div class="grid-replacements__fund__status">
                            <status-icons :status="[{ name: fund.fundStatus.name }]" />
                          </div>
                        </td>
                        <td class="mds-data-table__cell"></td>
                        <td class="mds-data-table__cell">
                          {{ fund.displayName }}
                        </td>
                        <td class="mds-data-table__cell">
                          {{ fund.ticker }}
                        </td>
                        <td class="mds-data-table__cell">
                          {{ fund.secID }}
                        </td>
                        <td class="mds-data-table__cell"></td>
                        <td class="mds-data-table__cell"></td>
                        <td class="mds-data-table__cell"></td>
                      </tr>
                      <tr :key="`category-replacement-${fund.id}`" class="mds-data-table__row">
                        <td class="grid-replacements__replacements" colspan="9">
                          <div class="grid-replacements__replacements__box">
                            <table
                              class="mds-data-table"
                              width="100%"
                              cellpadding="0"
                              cellspacing="0"
                            >
                              <tbody class="mds-data-table__body">
                                <template v-for="product in fund.products">
                                  <tr
                                    class="mds-data-table__row grid-replacements__replacements__box__fund"
                                    :key="`fund-${product.id}`"
                                  >
                                    <td class="mds-data-table__cell" width="20"></td>
                                    <td class="mds-data-table__cell" width="80"></td>
                                    <td class="mds-data-table__cell" width="80"></td>
                                    <td class="mds-data-table__cell" width="*">
                                      {{ product.name }} ({{ product.productCode }})
                                    </td>
                                    <td class="mds-data-table__cell" width="85"></td>
                                    <td class="mds-data-table__cell" width="117"></td>
                                    <td class="mds-data-table__cell" width="120"></td>
                                    <td class="mds-data-table__cell" width="80"></td>
                                    <td class="mds-data-table__cell" width="20"></td>
                                  </tr>
                                  <template v-if="!product.replacement">
                                    <tr
                                      :key="`replacement-${product.id}`"
                                      class="mds-data-table__row grid-replacements__replacements__box__replacement"
                                    >
                                      <td class="mds-data-table__cell" width="20"></td>
                                      <td class="mds-data-table__cell" width="80"></td>
                                      <td class="mds-data-table__cell" width="80"></td>
                                      <td
                                        @click="
                                          localPolicyOptions.options.select &&
                                            selectReplacement({ fund, product })
                                        "
                                        class="mds-data-table__cell grid-replacements__replacements__box__select"
                                        width="*"
                                      >
                                        <template v-if="localPolicyOptions.options.select">
                                          <div class="replacement_icon"></div>
                                          Select Replacement
                                        </template>
                                      </td>
                                      <td class="mds-data-table__cell" width="85"></td>
                                      <td class="mds-data-table__cell" width="117"></td>
                                      <td class="mds-data-table__cell" width="120"></td>
                                      <td class="mds-data-table__cell" width="80"></td>
                                      <td class="mds-data-table__cell" width="20"></td>
                                    </tr>
                                  </template>
                                  <template v-else>
                                    <tr
                                      :key="`replacement-${product.id}`"
                                      class="mds-data-table__row grid-replacements__replacements__box__selected"
                                    >
                                      <td class="mds-data-table__cell" width="20"></td>
                                      <td class="mds-data-table__cell" width="80">
                                        <div class="grid-replacements__fund__status">
                                          <status-icons
                                            :status="[
                                              { name: product.replacement.fundStatus.name },
                                            ]"
                                          />
                                        </div>
                                      </td>
                                      <td class="mds-data-table__cell" width="80">
                                        <div class="grid-replacements__fund__pending">
                                          <div
                                            v-if="product.replacement.isPending"
                                            class="mds-icon"
                                          >
                                            <base-grid-icon
                                              class="mds-icon"
                                              aria-hidden="true"
                                              icon="clock-back"
                                              tooltipMessage="Pending"
                                              @showToolTip="showTooltip"
                                              @hideToolTip="hideTooltip"
                                            />
                                          </div>
                                        </div>
                                      </td>
                                      <td class="mds-data-table__cell" width="*">
                                        {{ product.replacement.displayName }}
                                      </td>
                                      <td class="mds-data-table__cell" width="85">
                                        {{ product.replacement.ticker }}
                                      </td>
                                      <td class="mds-data-table__cell" width="117">
                                        {{ product.replacement.secID }}
                                      </td>
                                      <td class="mds-data-table__cell" width="120">
                                        <template v-if="tabsCurrent !== tabsProduction">
                                          <div class="grid-replacements__fund__edit">
                                            <mds-button
                                              class="mds-button mds-button--icon-only"
                                              variation="icon-only"
                                              icon="pencil"
                                              type="button"
                                              @click="selectReplacement({ fund, product })"
                                              @mouseover="$emit('showTooltip', $event, ['Edit Replacement'])"
                                              @mouseleave="$emit('hideTooltip')"
                                              v-if="localPolicyOptions.options.edit"
                                            >
                                            </mds-button>
                                          </div>
                                        </template>
                                        <template v-else>
                                          {{ product.replacement.activeDateFormatted }}
                                        </template>
                                      </td>
                                      <td class="mds-data-table__cell" width="80"></td>
                                      <td class="mds-data-table__cell" width="20"></td>
                                    </tr>
                                  </template>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
          <template v-else>
            <div v-if="!(selectedProduct !== 0 || categories.length > 0)" class="empty-state">
              <p>{{ tabs[tabsIndex].empty }}</p>
            </div>
            <div v-else class="empty-state left">
              <p>
                No items displayed
              </p>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="empty-state">
            <p>You don't have any removed funds that need replacement funds.</p>
            <p class="sub">
              To remove a fund, go to the
              <span class="mds-link" @click="gotoAllClients">All Clients</span>
              or to the
              <span class="mds-link" @click="gotoUniverse">{{ selectedClientName }} Universe</span>
            </p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
import {
  cloneDeep,
  chain,
  findIndex,
  get,
  merge,
  sortBy,
} from 'lodash';

import { EventBus } from '@/utils/event-bus';

import StatusIcons from '@/components/atoms/StatusIcons';
import BaseGridIcon from '@/components/atoms/BaseGridIcon';
import FilterBar from '@/components/organisms/FilterBar';
import { getReplacementsDataOfFiduciaryClient } from '@/services/FiduciaryClients';

export default {
  name: 'grid-replacements',
  components: {
    StatusIcons,
    BaseGridIcon,
    FilterBar,
  },
  data() {
    return {
      tabs: [
        {
          label: 'In Progress',
          name: 'in-progress',
          value: 'inProgress',
          empty: "You don't have any removed funds that need replacement funds.",
        },
        {
          label: 'Active',
          name: 'active',
          value: 'active',
          empty: "You don't have any active replacement funds.",
        },
      ],
      tabsDefault: 'inProgress',
      tabsProduction: 'active',
      tabsCurrent: '',
      tabsIndex: 0,
      loading: false,
      haveData: false,
      dataReplacements: [],
      replacements: [],
      hideFilters: {
        classes: true,
        statuses: true,
        updates: true,
        dateRange: true,
      },
      categories: [],
      allStatusMode: false,
      clearAllFilters: false,
    };
  },
  computed: {
    ...mapState({
      policies: (state) => state.user.policies,
      selectedFiduciary: (state) => state.user.fiduciary.id,
      selectedClient: (state) => state.grid.client.selected,
      selectedClientName: (state) => state.grid.client.name,
      selectedTab: (state) => state.grid.tab,
      selectedProduct: (state) => state.grid.product.selected,
      selectedProductName: (state) => state.grid.product.name,
      searchTerm: (state) => state.grid.searchTerm,
    }),
    currentViewName() {
      return this.selectedClient > 0 ? 'one-client' : 'all-clients';
    },
    localPolicyOptions() {
      // Tabs are applied to 1 Client View
      if (this.currentViewName === 'all-clients') {
        return get(this.policies, `grid.views.${this.currentViewName}`);
      }
      return get(this.policies, `grid.views.${this.currentViewName}.tabs.${this.selectedTab}`);
    },
  },
  watch: {
    tabsCurrent(newValue) {
      const [selected = {}] = this.dataReplacements.filter((tab) => tab.name === newValue);
      const { value = [] } = selected;
      this.replacements = value;
      this.clearAllFilters = true;
      EventBus.$emit('search-clear');
    },
    categories() {
      this.filterReplacements();
      this.clearAllFilters = false;
    },
    selectedProduct() {
      this.filterReplacements();
      this.clearAllFilters = false;
    },
    searchTerm() {
      this.filterReplacements();
      this.clearAllFilters = false;
    },
  },
  created() {
    /* eslint-disable no-param-reassign */
    this.loading = true;

    getReplacementsDataOfFiduciaryClient({
      selectedClient: this.selectedClient,
    }).then((result) => {
      if (result.status.success) {
        this.loading = false;

        const { data = {} } = result;
        this.haveData = data.inProgress.length > 0 || data.active.length > 0;

        this.dataReplacements = chain(data)
          .toPairs()
          .map((item) => {
            const [name, value = []] = item;
            return { name, value };
          })
          .map((tab) => {
            const { name, value } = tab;
            return {
              name,
              value: chain(value)
                .groupBy((fund) => fund.psaCategory.name)
                .toPairs()
                .map((categoryGroup) => {
                  const [category, funds] = categoryGroup;
                  return { category, funds };
                })
                .sortBy('category')
                .value(),
            };
          })
          .map((tab) => {
            tab.value = tab.value.map((category) => {
              category.funds = sortBy(category.funds, 'displayName');
              category.funds = category.funds.map((fund) => {
                fund.products = sortBy(fund.products, 'name');
                fund.products = fund.products.map((product) => {
                  const modifProduct = cloneDeep(product);
                  if (modifProduct.replacement) {
                    if (modifProduct.replacement.pendingStatus) {
                      merge(
                        modifProduct.replacement.fundStatus,
                        modifProduct.replacement.pendingStatus,
                      );
                    }
                    if (modifProduct.replacement.activeDate) {
                      const date = new Date(modifProduct.replacement.activeDate);
                      modifProduct.replacement.activeDateFormatted = format(date, 'MMM D, YYYY');
                    }
                  }
                  return modifProduct;
                });
                if (fund.pendingStatus && tab.name !== this.tabsProduction) {
                  merge(fund.fundStatus, fund.pendingStatus);
                }
                return fund;
              });
              return category;
            });
            return tab;
          })
          .value();
        this.tabsCurrent = this.tabsDefault;
      }
    }).catch((error) => {
      const httpStatus = (error?.response.status) ? (error?.response.status) : error?.status;
      if (httpStatus === 401) {
        this.$router.push('/Login');
      }
    }).finally(() => {
      this.loading = false;
    });

    EventBus.$emit('search-clear');
    /* eslint-enable no-param-reassign */
  },
  methods: {
    setReplacementTab(newTab) {
      this.tabsCurrent = newTab;
      this.tabsIndex = findIndex(this.tabs, (tab) => tab.value === newTab);
    },
    gotoAllClients() {
      this.$store.dispatch('setClient', {
        listVisible: false,
        name: 'All Clients',
        code: '',
        selected: 0,
      });
      this.$store.dispatch('setTab', 'universe');
      this.$store.dispatch('closeNotification');
    },
    gotoUniverse() {
      this.$store.dispatch('setTab', 'universe');
    },
    selectReplacement({ fund = {}, product = {} }) {
      this.$store.dispatch('openFullscreenModal', {
        title: 'Select Replacement',
        component: 'select-replacement',
        data: {
          fund,
          product,
          callback: (selected) => {
            const inProgress = this.dataReplacements[0].value;

            this.replacements = inProgress.map((category) => {
              const categoryToReplace = category;

              categoryToReplace.funds = categoryToReplace.funds.map((fundCategory) => {
                const fundToReplace = fundCategory;

                if (fundToReplace.id === fund.id) {
                  fundToReplace.products = fundToReplace.products.map((productFund) => {
                    const productToReplace = productFund;

                    if (productToReplace.id === product.id) {
                      productToReplace.replacement = selected.fiduciaryFund;
                    }

                    return productToReplace;
                  });
                }
                return fundToReplace;
              });
              return categoryToReplace;
            });
          },
        },
      });
    },
    updateFilters(filters, allStatus) {
      this.categories = filters.categories;
      this.allStatusMode = allStatus;
    },
    updateProduct(product, productName, productCode) {
      this.$store.dispatch('setProduct', {
        code: productCode,
        listVisible: false,
        name: productName,
        selected: product,
      });
    },
    filterReplacements() {
      /* eslint-disable no-param-reassign */
      const replacements = cloneDeep(this.dataReplacements[this.tabsIndex].value);
      this.replacements = replacements
        .filter((item) => {
          if (this.categories.length > 0) {
            if (this.categories.indexOf(item.category) > -1) {
              return true;
            }
          } else {
            return true;
          }
          return false;
        })
        .filter((item) => {
          item.funds = item.funds.filter((fund) => {
            fund.products = fund.products.filter((product) => {
              if (this.selectedProduct > 0) {
                if (this.selectedProductName === product.name) {
                  return true;
                }
              } else {
                return true;
              }
              return false;
            });
            return true;
          });
          return true;
        })
        .filter((item) => {
          item.funds = item.funds.filter((fund) => {
            if (this.searchTerm) {
              const matchName = new RegExp(this.searchTerm, 'gi').test(fund.displayName);
              const matchTicker = new RegExp(this.searchTerm, 'gi').test(fund.ticker);
              const matchSecID = new RegExp(this.searchTerm, 'gi').test(fund.secID);

              const searchFund = matchName || matchTicker || matchSecID;
              let foundSomeProduct = false;

              if (!searchFund) {
                fund.products = fund.products.filter((product) => {
                  if (product.replacement) {
                    const matchProductName = new RegExp(this.searchTerm, 'gi').test(
                      product.replacement.displayName,
                    );
                    const matchProductTicker = new RegExp(this.searchTerm, 'gi').test(
                      product.replacement.ticker,
                    );
                    const matchProductSecID = new RegExp(this.searchTerm, 'gi').test(
                      product.replacement.secID,
                    );

                    const searchProduct = matchProductName
                      || matchProductTicker
                      || matchProductSecID;

                    if (searchProduct) {
                      foundSomeProduct = true;
                      return true;
                    }
                  } else {
                    return true;
                  }
                  return false;
                });
              }
              return searchFund || foundSomeProduct;
            }
            return true;
          });
          return true;
        });
      /* eslint-enable no-param-reassign */
    },
    showTooltip(...args) {
      this.$emit('showTooltip', ...args);
    },
    hideTooltip() {
      this.$emit('hideTooltip');
    },
  },
};
</script>

<style lang="scss">
.grid-replacements {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 0; // Firefox Flexbox fix

  &__container {
    height: 100%;
    overflow-y: auto;
  }

  &__wrapper {
    padding: 0 $mds-space-4-x $mds-space-4-x $mds-space-4-x;
  }

  &__category {
    &__name {
      @include mds-level-4-heading();
      margin-bottom: $mds-space-2-x;
      margin-top: $mds-space-4-x;
    }
    &__container {
      background-color: $mds-background-color-light-gray;
      padding: $mds-space-2-x $mds-space-4-x;
    }
    .mds-data-table {
      border-collapse: separate;
      border-spacing: 0 $mds-space-2-x;
    }
    .mds-data-table__header-cell {
      padding: 0;
    }
    .mds-data-table__header-cell-inner {
      font-weight: bold;
      padding: 0;
      margin: 0;
    }
    .mds-data-table__header-cell-inner--center {
      text-align: center;
    }
    .mds-button--icon-only {
      margin-top: -$mds-space-three-quarter-x;
      width: 22px;
      height: 22px;
      border-radius: $mds-space-three-quarter-x;
      text-align: center;
      display: none;
      &.baseGridIcon {
        display: block;
      }
    }
    .mds-button--icon-only:hover {
      background-color: #e0f3fb;
    }
  }
  &__fund {
    &__status {
      padding-left: $mds-space-1-x;
    }
    &__pending {
      padding-left: $mds-space-1-and-a-half-x;
    }
    &__edit {
      padding-left: $mds-space-1-and-a-half-x;
    }
    .mds-data-table__cell {
      background-color: $mds-background-color-alternative-row-on-light;
      padding: $mds-space-2-x 0;
    }
  }
  &__replacements {
    &__box {
      border-radius: 6px;
      background-color: $mds-color-white;
      box-shadow: 0 -2px 8px 0 rgba(219, 219, 219, 0.4), 0 8px 20px 0 #dbdbdb;
      padding: $mds-space-2-x 0 $mds-space-4-x 0;

      &__replacement {
        td {
          background-color: rgba(171, 171, 171, 0.1);
        }
        td:last-child,
        td:nth-last-child(2) {
          background-color: $mds-color-white;
        }
        .replacement_icon {
          background-image: url("/static/assets/replacement_icon_ct.svg");
          display: inline-block;
          height: 19px;
          margin: 0 $mds-space-1-x -2px 0;
          width: 22px;
        }
        &:hover td {
          background-color: #f7fffd;
          cursor: pointer;
        }
        &:hover td:first-child,
        &:hover td:nth-child(2) {
          background-color: $mds-color-white;
        }
        &:hover td:last-child,
        &:hover td:nth-last-child(2) {
          background-color: $mds-color-white;
        }
      }
      &__selected {
        td {
          background-color: #f7fffd;
        }
        td:last-child,
        td:nth-last-child(2) {
          background-color: $mds-color-white;
        }
        &:hover .mds-button--icon-only {
          display: block;
        }
      }
      .mds-data-table {
        border-collapse: collapse;
        border-spacing: 0;
      }
      .mds-data-table__cell {
        border-top: 0;
        padding: $mds-space-2-x 0;
      }
      .mds-data-table__cell:first-child,
      .mds-data-table__cell:nth-child(2),
      .mds-data-table__cell td:last-child {
        background-color: $mds-color-white;
      }
    }
  }

  .filter-bar__container {
    padding-left: 0;
  }

  @media screen and (max-height: 750px) {
    .single-list, .multiple-list {
      max-height: 130px;
    }
  }
}

.empty-state {
  font-family: $mds-font-family-sans-serif;
  font-size: $mds-font-size-m;
  margin-top: $mds-space-4-x 0;
  text-align: center;

  .sub {
    font-size: $mds-font-size-s;
  }
}
.empty-state.left {
  text-align: left;
}
</style>
